import React, { createRef } from 'react';
// import {Card, Col, Row} from 'react-bootstrap';
// import MyButton from '../../component/Button';
// import moment from 'moment';
// import HTMLViewer from '../../component/HTMLViewer';

// // import Editor from "@toast-ui/editor";
// // import "codemirror/lib/codemirror.css"; // Editor's Dependency Style
// // import "@toast-ui/editor/dist/toastui-editor.css"; // Editor's Style
// import {GetNotice, ModifyNoticeStatus} from '../../lib/Notice';
// import Aux from '../../hoc/_Aux';

// // import EditContent from "./components/editContent";
// import PopupWanning from '../Popup/Wanning';
// import PopupBasic from '../Popup/Basic';
// import PopupComplete from '../Popup/Complete';

class FormsElements extends React.Component {
    constructor(props) {
        super(props);

        // this.id = this.props.match.params.id;
        // this.role = localStorage.getItem('role');

        // this.state = {
        //     data: {
        //         notice: {
        //             noticeId: 0,
        //             writerId: 0,
        //             createTime: '',
        //             beginTime: '',
        //             endTime: '',
        //             unlimited: false,
        //             priority: 'NORMAL',
        //             expired: false,
        //             viewCount: 0,
        //         },
        //         status: 'WAIT',
        //         noticeTrs: [
        //             {
        //                 noticeId: 0,
        //                 language: 'KO',
        //                 sort: 0,
        //                 subject: '',
        //                 content: '',
        //             },
        //         ],
        //     },
        //     selectLanguage: 'KO',
        //     status: {
        //         WAIT: '대기중',
        //         POSTED: '게시중',
        //         EXPIRED: '게시 만료',
        //     },
        //     language: {
        //         KO: '한국어',
        //         EN: '영어',
        //         ZH: '중국어',
        //         JA: '일본어',
        //     },
        // };

        // this.popupBasic = createRef();
        // this.popupWanning = createRef();
        // this.popupComplete = createRef();

        // if (this.id !== undefined) {
        //     GetNotice(this, this.id, this.resultGet.bind(this));
        // }
    }

    // /**
    //  * 정보
    //  */
    // resultGet = response => {
    //     this.setState({
    //         data: response,
    //     });
    // };

    // /**
    //  * 게시중단
    //  */
    // resultModifyNoticeStatus = response => {
    //     this.props.history.goBack();
    // };

    render() {
        // const { data, selectLanguage, status } = this.state;
        // const langs = data.noticeTrs.map(x => x.language);
        // const noticeTrs = data.noticeTrs.find(x => x.language === selectLanguage);
        // console.log('noticeTrs', noticeTrs);

        return (
            // <Aux>
            //     <Row>
            //         <Col>
            //             {/* 공지사항 상세페이지 */}
            //             <Card>
            //                 <div className="notice_view_box">
            //                     <div className="tab_box">
            //                         <ul className="tab_in_ul lang">
            //                             {langs.includes('KO') && (
            //                                 <li
            //                                     className={this.state.selectLanguage === 'KO' && 'active'}
            //                                     onClick={e => {
            //                                         this.setState({ selectLanguage: 'KO' });
            //                                     }}
            //                                 >
            //                                     <a href="javascript:;">한국어</a>
            //                                 </li>
            //                             )}
            //                             {langs.includes('EN') && (
            //                                 <li
            //                                     className={this.state.selectLanguage === 'EN' && 'active'}
            //                                     onClick={e => {
            //                                         this.setState({ selectLanguage: 'EN' });
            //                                     }}
            //                                 >
            //                                     <a href="javascript:;">영어</a>
            //                                 </li>
            //                             )}
            //                             {langs.includes('ZH') && (
            //                                 <li
            //                                     className={this.state.selectLanguage === 'ZH' && 'active'}
            //                                     onClick={e => {
            //                                         this.setState({ selectLanguage: 'ZH' });
            //                                     }}
            //                                 >
            //                                     <a href="javascript:;">중국어</a>
            //                                 </li>
            //                             )}
            //                             {langs.includes('JA') && (
            //                                 <li
            //                                     className={this.state.selectLanguage === 'JA' && 'active'}
            //                                     onClick={e => {
            //                                         this.setState({ selectLanguage: 'JA' });
            //                                     }}
            //                                 >
            //                                     <a href="javascript:;">일본어</a>
            //                                 </li>
            //                             )}
            //                         </ul>
            //                     </div>

            //                     <div className="no_view_info_box">
            //                         <div className="tit_box">
            //                             <span className="cate gray">{status[data.status]}</span>
            //                             <span className="title">{noticeTrs.subject}</span>
            //                         </div>
            //                         <div className="info_box">
            //                             <dl className="lb">
            //                                 {/* <dt>작성자</dt>
            //                                 <dd>{data.notice.writerId}</dd> */}
            //                             </dl>
            //                             <dl className="rb">
            //                                 <dt>작성일</dt>
            //                                 <dd>{moment(data.notice.createTime).format('YYYY.MM.DD HH:mm')}</dd>
            //                             </dl>
            //                         </div>
            //                     </div>

            //                     {/* <div className="no_view_content_box" dangerouslySetInnerHTML={{ __html: noticeTrs.content }}></div> */}
            //                     <div className="no_view_content_box">
            //                         <HTMLViewer html={noticeTrs.content} />
            //                     </div>

            //                     {this.role === 'SUPER_ADMIN' && (
            //                         <div className="btn_box" style={{ borderTop: '1px solid #ddd', textAlign: 'right' }}>
            //                             <MyButton title="목록으로" variant="outline-primary" onClick={e => this.props.history.push('/notice/list')} />
            //                             {data.status !== 'EXPIRED' && (
            //                                 <MyButton
            //                                     title="수정하기"
            //                                     variant="outline-primary"
            //                                     onClick={e => this.props.history.push('/notice/edit/' + this.id)}
            //                                 />
            //                             )}
            //                             {data.status !== 'EXPIRED' && (
            //                                 <MyButton
            //                                     title="게시 중단 하기"
            //                                     variant="primary"
            //                                     onClick={e => {
            //                                         this.popupBasic.current.open('', '게시를 중단 하시겠습니까?', '중단', e => {
            //                                             // ModifyManagerStatus(this, item.id, "ENABLED", e => {
            //                                             //     this.popupComplete.current.open("매니저 계정이 활성화되었습니다.", "", "확인", e => {});
            //                                             // });
            //                                             ModifyNoticeStatus(this, this.id, true, this.resultModifyNoticeStatus.bind(this));
            //                                         });
            //                                     }}
            //                                 />
            //                             )}
            //                         </div>
            //                     )}
            //                 </div>
            //             </Card>
            //             {/* 공지사항 상세페이지 - end */}
            //         </Col>
            //     </Row>
            //     <PopupWanning ref={this.popupWanning} />
            //     <PopupBasic ref={this.popupBasic} />
            //     <PopupComplete ref={this.popupComplete} />
            // </Aux>
            <div></div>
        );
    }
}

export default FormsElements;
